import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { MODAL_KEYS } from '_constants/modals';
import { theme } from '_constants/theme';
import { selectData, selectFetchCounter, selectLoading } from '_store/meetings/selector';
import { getMeetings } from '_store/meetings/slice';
import { showModal } from '_store/modals/slice';
import { selectCustomerId } from '_store/user/selector';

import Button from 'components/atomic/Button';
import Card from 'components/atomic/layouts/Card';
import Text from 'components/atomic/layouts/Text';

import MeetingList from './MeetingList';

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.spaces.large}px;
`;

const StyledTitleContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
`;

const StyledBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const StyledFooter = styled.div`
  padding-top: ${theme.spaces.large}px;
`;

const StyledEmptyDataContainer = styled.div`
  padding-top: ${theme.spaces.medium}px;
`;

const BookMeetingView = () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);
  const loading = useSelector(selectLoading);
  const data = useSelector(selectData);
  const fetchCounter = useSelector(selectFetchCounter);

  useEffect(() => {
    if (customerId && !fetchCounter) {
      dispatch(getMeetings({ customerId }));
    }
  }, [customerId, fetchCounter]);

  return (
    <StyledCard>
      <StyledHeader>
        <StyledTitleContainer>
          <Text size={theme.fontSizes.medium} weight={600}>
            Book a tax prep meeting
          </Text>
        </StyledTitleContainer>
      </StyledHeader>

      <StyledBody>
        <MeetingList loading={loading} items={data} />
        {!loading && !data?.length && (
          <StyledEmptyDataContainer>
            <Text size={theme.fontSizes.small} weight={400} color={theme.colors.gray.primary} centered>
              No data available
            </Text>
          </StyledEmptyDataContainer>
        )}
      </StyledBody>

      <StyledFooter>
        <Button
          color={theme.colors.green.primary}
          onClick={() => {
            dispatch(showModal({ key: MODAL_KEYS.appointmentScheduling }));
          }}
        >
          Book a Meeting
        </Button>
      </StyledFooter>
    </StyledCard>
  );
};

export default BookMeetingView;
